module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmtit"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _vm._v("Glossary")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter10#G1",
      "id": "rG1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A&AEE")])])])]), _vm._v(" "), _c('td', [_vm._v("Aeroplane and Armament Experimental Establishment")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter10#G2",
      "id": "rG2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AAA")])])])]), _vm._v(" "), _c('td', [_vm._v("Anti-Aircraft Artillery")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter8#G3",
      "id": "rG3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AAR")])])])]), _vm._v(" "), _c('td', [_vm._v("Air-to-air-refuelling (also known as ‘tanking’)")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter5#G4",
      "id": "rG4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AC")])])])]), _vm._v(" "), _c('td', [_vm._v("Alternating current")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter5#G5",
      "id": "rG5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ACE")])])])]), _vm._v(" "), _c('td', [_vm._v("Allied Command Europe")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter5#G6",
      "id": "rG6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ACL")])])])]), _vm._v(" "), _c('td', [_vm._v("Air Combat Leader")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter5#G7",
      "id": "rG7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ACM")])])])]), _vm._v(" "), _c('td', [_vm._v("Air Combat Manoeuvring")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter9#G8",
      "id": "rG8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ACMI")])])])]), _vm._v(" "), _c('td', [_vm._v("Air Combat Manoeuvring Instrumentation (Range)")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter3#G9",
      "id": "rG9"
    }
  }, [_vm._v("ACT")])])])]), _vm._v(" "), _c('td', [_vm._v("Air Combat Training")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("AD")])])]), _vm._v(" "), _c('td', [_vm._v("Air Defence")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter9#G10",
      "id": "rG10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ADV")])])])]), _vm._v(" "), _c('td', [_vm._v("Air Defence Variant (of Tornado)")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter6#G11",
      "id": "rG11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AEF")])])])]), _vm._v(" "), _c('td', [_vm._v("Air Experience Flight")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter3#G12",
      "id": "rG12"
    }
  }, [_vm._v("AFTS")])])])]), _vm._v(" "), _c('td', [_vm._v("Advanced Flying Training School")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter4#G13",
      "id": "rG13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AI")])])])]), _vm._v(" "), _c('td', [_vm._v("Air Intercept (designation for fighter radars)")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter7#G14",
      "id": "rG14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AIM")])])])]), _vm._v(" "), _c('td', [_vm._v("Air Intercept Missile (e.g. AIM-9L)")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter11#G15",
      "id": "rG15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AMLCD")])])])]), _vm._v(" "), _c('td', [_vm._v("Active Matrix Liquid Crystal Display")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Prologue#G16",
      "id": "rG16"
    }
  }, [_vm._v("AMRAAM")])])])]), _vm._v(" "), _c('td', [_vm._v("Advanced Medium-Range Air-to-Air Missile (also known as AIM-120)")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter9#G17",
      "id": "rG17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AOA")])])])]), _vm._v(" "), _c('td', [_vm._v("Angle of Attack")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Listofplates#G18",
      "id": "rG18"
    }
  }, [_vm._v("AOC")])])])]), _vm._v(" "), _c('td', [_vm._v("Air Officer Commanding (an "), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Listofplates#G99",
      "id": "rG99"
    }
  }, [_vm._v("RAF")]), _vm._v(" Group)")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter5#G19",
      "id": "rG19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APC")])])])]), _vm._v(" "), _c('td', [_vm._v("Armament Practice Camp")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter5#G20",
      "id": "rG20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ASAP")])])])]), _vm._v(" "), _c('td', [_vm._v("As Soon As Possible")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Prologue#G21",
      "id": "rG21"
    }
  }, [_vm._v("ASRAAM")])])])]), _vm._v(" "), _c('td', [_vm._v("Advanced Short-Range Air-to-Air Missile")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter5#G22",
      "id": "rG22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ATC")])])])]), _vm._v(" "), _c('td', [_vm._v("Air Traffic Control")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter9#G23",
      "id": "rG23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AWACS")])])])]), _vm._v(" "), _c('td', [_vm._v("Airborne Warning and Control System")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter10#G24",
      "id": "rG24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AWC")])])])]), _vm._v(" "), _c('td', [_vm._v("Air Warfare Centre")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Listofplates#G25",
      "id": "rG25"
    }
  }, [_vm._v("BBMF")])])])]), _vm._v(" "), _c('td', [_vm._v("Battle of Britain Memorial Flight")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("BFT(S)")])])]), _vm._v(" "), _c('td', [_vm._v("Basic Flying Training (School)")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Prologue#G26",
      "id": "rG26"
    }
  }, [_vm._v("BVR")])])])]), _vm._v(" "), _c('td', [_vm._v("Beyond Visual Range")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter5#G27",
      "id": "rG27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CAP")])])])]), _vm._v(" "), _c('td', [_vm._v("Combat Air Patrol")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CBFFI")])])]), _vm._v(" "), _c('td', [_vm._v("Commander British Forces Falkland Islands")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter7#G28",
      "id": "rG28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CBLS")])])])]), _vm._v(" "), _c('td', [_vm._v("Carrier Bomb Light Stores")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter1#G29",
      "id": "rG29"
    }
  }, [_vm._v("CCF")])])])]), _vm._v(" "), _c('td', [_vm._v("Combined Cadet Force")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter9#G30",
      "id": "rG30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CFB")])])])]), _vm._v(" "), _c('td', [_vm._v("Canadian Forces Base")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter1#G31",
      "id": "rG31"
    }
  }, [_vm._v("CFI")])])])]), _vm._v(" "), _c('td', [_vm._v("Chief Flying Instructor")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter9#G32",
      "id": "rG32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CFIT")])])])]), _vm._v(" "), _c('td', [_vm._v("Controlled Flight into Terrain")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter5#G33",
      "id": "rG33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CFS")])])])]), _vm._v(" "), _c('td', [_vm._v("Central Flying School")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter5#G34",
      "id": "rG34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C-in-C")])])])]), _vm._v(" "), _c('td', [_vm._v("Commander-in-Chief (actually AOC-in-C – Air Officer Commanding in Chief)")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter11#G35",
      "id": "rG35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CSP")])])])]), _vm._v(" "), _c('td', [_vm._v("Capability Sustainment Programme")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter10#G36",
      "id": "rG36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CTTO")])])])]), _vm._v(" "), _c('td', [_vm._v("Central Trials and Tactics Organisation (forerunner of the Air Warfare Centre)")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter5#G37",
      "id": "rG37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DACT")])])])]), _vm._v(" "), _c('td', [_vm._v("Dissimilar (types) Air Combat Training")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter6#G38",
      "id": "rG38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DH")])])])]), _vm._v(" "), _c('td', [_vm._v("Direct Hit")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("DRA")])])]), _vm._v(" "), _c('td', [_vm._v("Defence Research Agency")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter10#G39",
      "id": "rG39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ECCM")])])])]), _vm._v(" "), _c('td', [_vm._v("Electronic Counter-Counter Measures")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter8#G40",
      "id": "rG40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ECM")])])])]), _vm._v(" "), _c('td', [_vm._v("Electronic Counter Measures")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter3#G41",
      "id": "rG41"
    }
  }, [_vm._v("EFT(S)")])])])]), _vm._v(" "), _c('td', [_vm._v("Elementary Flying Training (School)")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter10#G42",
      "id": "rG42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EWO")])])])]), _vm._v(" "), _c('td', [_vm._v("Electronic Warfare Officer")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter5#G43",
      "id": "rG43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FEZ")])])])]), _vm._v(" "), _c('td', [_vm._v("Fighter Engagement Zone")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter11#G44",
      "id": "rG44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FIPZ")])])])]), _vm._v(" "), _c('td', [_vm._v("Falkland Islands Protection Zone")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("FOX 1")])])]), _vm._v(" "), _c('td', [_vm._v("Launch of a semi-active radar missile")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("FOX 2")])])]), _vm._v(" "), _c('td', [_vm._v("Launch of an infra-red homing missile")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter3#G45",
      "id": "rG45"
    }
  }, [_vm._v("FRA")])])])]), _vm._v(" "), _c('td', [_vm._v("First Run Attack")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Appendix1#G46",
      "id": "rG46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FTRS")])])])]), _vm._v(" "), _c('td', [_vm._v("Full-Time Reserve Service")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Listofplates#G47",
      "id": "rG47"
    }
  }, [_vm._v("FTS")])])])]), _vm._v(" "), _c('td', [_vm._v("Flying Training School")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter5#G48",
      "id": "rG48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GCA")])])])]), _vm._v(" "), _c('td', [_vm._v("Ground Controlled Approach (to a runway)")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter11#G49",
      "id": "rG49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GCI")])])])]), _vm._v(" "), _c('td', [_vm._v("Ground Controlled Intercept")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter9#G50",
      "id": "rG50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GPS")])])])]), _vm._v(" "), _c('td', [_vm._v("Global Positioning System")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter11#G51",
      "id": "rG51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GPWS")])])])]), _vm._v(" "), _c('td', [_vm._v("Ground Proximity Warning System")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter9#G52",
      "id": "rG52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HAF")])])])]), _vm._v(" "), _c('td', [_vm._v("Hellenic (Greek) Air Force")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter9#G53",
      "id": "rG53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HAS")])])])]), _vm._v(" "), _c('td', [_vm._v("Hardened Aircraft Shelter")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("HIMAT")])])]), _vm._v(" "), _c('td', [_vm._v("High Mass Altitude and Temperature")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter9#G54",
      "id": "rG54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HOTAS")])])])]), _vm._v(" "), _c('td', [_vm._v("Hands on Throttle and Stick")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter7#G55",
      "id": "rG55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HQ")])])])]), _vm._v(" "), _c('td', [_vm._v("Headquarters")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter9#G56",
      "id": "rG56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HUD")])])])]), _vm._v(" "), _c('td', [_vm._v("Head-Up Display")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter9#G57",
      "id": "rG57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IADS")])])])]), _vm._v(" "), _c('td', [_vm._v("Integrated Air Defence System")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter9#G58",
      "id": "rG58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IDS")])])])]), _vm._v(" "), _c('td', [_vm._v("Interdictor Strike (variant of Tornado)")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter9#G59",
      "id": "rG59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IFF")])])])]), _vm._v(" "), _c('td', [_vm._v("Identification Friend or Foe")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter10#G60",
      "id": "rG60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IRCCM")])])])]), _vm._v(" "), _c('td', [_vm._v("Infra-Red Counter-Counter Measures")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter10#G61",
      "id": "rG61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IRCM")])])])]), _vm._v(" "), _c('td', [_vm._v("Infra-Red Counter Measures")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter5#G62",
      "id": "rG62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IRE")])])])]), _vm._v(" "), _c('td', [_vm._v("Instrument Rating Examiner")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("IRT")])])]), _vm._v(" "), _c('td', [_vm._v("Instrument Rating Test")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ISS")])])]), _vm._v(" "), _c('td', [_vm._v("Individual Staff Studies")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter5#G63",
      "id": "rG63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IWI")])])])]), _vm._v(" "), _c('td', [_vm._v("Intercept Weapons Instructor (Lightnings)")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter3#G64",
      "id": "rG64"
    }
  }, [_vm._v("JP")])])])]), _vm._v(" "), _c('td', [_vm._v("Junior pilot")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter3#G65",
      "id": "rG65"
    }
  }, [_vm._v("JP 3")])])])]), _vm._v(" "), _c('td', [_vm._v("Jet Provost T.3")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter3#G66",
      "id": "rG66"
    }
  }, [_vm._v("JP 5")])])])]), _vm._v(" "), _c('td', [_vm._v("Jet Provost T.5")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter10#G67",
      "id": "rG67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JTIDS")])])])]), _vm._v(" "), _c('td', [_vm._v("Joint Tactical Information Distribution System (‘Link 16’ Datalink)")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter12#G68",
      "id": "rG68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LLA")])])])]), _vm._v(" "), _c('td', [_vm._v("Lincolnshire’s Lancaster Association (charity)")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter5#G69",
      "id": "rG69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LLSP")])])])]), _vm._v(" "), _c('td', [_vm._v("Low Level Search Pattern")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Listofplates#G70",
      "id": "rG70"
    }
  }, [_vm._v("LTF")])])])]), _vm._v(" "), _c('td', [_vm._v("Lightning Training Flight")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter6#G71",
      "id": "rG71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LUAS")])])])]), _vm._v(" "), _c('td', [_vm._v("Liverpool University Air Squadron")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter4#G72",
      "id": "rG72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("M")])])])]), _vm._v(" "), _c('td', [_vm._v("Mach (number) – speed relative to the speed of sound (M1.0)")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter6#G73",
      "id": "rG73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MASUAS")])])])]), _vm._v(" "), _c('td', [_vm._v("Manchester and Salford University Air Squadron")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Listofplates#G74",
      "id": "rG74"
    }
  }, [_vm._v("MBE")])])])]), _vm._v(" "), _c('td', [_vm._v("Member (of the Order of the) British Empire")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter5#G75",
      "id": "rG75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MEZ")])])])]), _vm._v(" "), _c('td', [_vm._v("(Surface -to-air) Missile Engagement Zone")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter7#G76",
      "id": "rG76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MFF")])])])]), _vm._v(" "), _c('td', [_vm._v("Mixed Fighter Force")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Listofplates#G77",
      "id": "rG77"
    }
  }, [_vm._v("MoD")])])])]), _vm._v(" "), _c('td', [_vm._v("Ministry of Defence")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter11#G78",
      "id": "rG78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MPA")])])])]), _vm._v(" "), _c('td', [_vm._v("Mount Pleasant Airfield (Falklands)")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter8#G79",
      "id": "rG79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MPC")])])])]), _vm._v(" "), _c('td', [_vm._v("Missile Practice Camp")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter4#G80",
      "id": "rG80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NATO")])])])]), _vm._v(" "), _c('td', [_vm._v("North Atlantic Treaty Organization")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Navex")])])]), _vm._v(" "), _c('td', [_vm._v("Navigation exercise")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter9#G81",
      "id": "rG81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NBC")])])])]), _vm._v(" "), _c('td', [_vm._v("Nuclear Biological and Chemical")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter1#G82",
      "id": "rG82"
    }
  }, [_vm._v("NCO")])])])]), _vm._v(" "), _c('td', [_vm._v("Non-Commissioned Officer (e.g. Sergeant)")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter9#G83",
      "id": "rG83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NVGs")])])])]), _vm._v(" "), _c('td', [_vm._v("Night Vision Goggles")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter1#G84",
      "id": "rG84"
    }
  }, [_vm._v("OASC")])])])]), _vm._v(" "), _c('td', [_vm._v("Officer and Aircrew Selection Centre")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Listofplates#G85",
      "id": "rG85"
    }
  }, [_vm._v("OC")])])])]), _vm._v(" "), _c('td', [_vm._v("Officer Commanding")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter5#G86",
      "id": "rG86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OC Eng. Wing")])])])]), _vm._v(" "), _c('td', [_vm._v("Officer Commanding Engineering Wing")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter4#G87",
      "id": "rG87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OCU")])])])]), _vm._v(" "), _c('td', [_vm._v("Operational Conversion Unit")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Listofplates#G88",
      "id": "rG88"
    }
  }, [_vm._v("OEU")])])])]), _vm._v(" "), _c('td', [_vm._v("Operational Evaluation Unit")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter5#G89",
      "id": "rG89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ops")])])])]), _vm._v(" "), _c('td', [_vm._v("Operations")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter12#G90",
      "id": "rG90",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PAN")]), _vm._v(" Call")])])]), _vm._v(" "), _c('td', [_vm._v("International standard radio call notifying an urgent situation that does not pose an immediate danger to life or the aircraft.")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter9#G91",
      "id": "rG91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PBF")])])])]), _vm._v(" "), _c('td', [_vm._v("Pilot Briefing Facility")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter4#G92",
      "id": "rG92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PI")])])])]), _vm._v(" "), _c('td', [_vm._v("Practice intercept")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PLB")])])]), _vm._v(" "), _c('td', [_vm._v("Personal Locator Beacon")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter1#G93",
      "id": "rG93"
    }
  }, [_vm._v("PPL")])])])]), _vm._v(" "), _c('td', [_vm._v("Private Pilot’s Licence")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PSI")])])]), _vm._v(" "), _c('td', [_vm._v("Pounds per Square Inch (pressure)")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter3#G94",
      "id": "rG94"
    }
  }, [_vm._v("QFI")])])])]), _vm._v(" "), _c('td', [_vm._v("Qualified Flying Instructor")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter5#G95",
      "id": "rG95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("QRA")])])])]), _vm._v(" "), _c('td', [_vm._v("Quick Reaction Alert")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter10#G96",
      "id": "rG96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("QTI")])])])]), _vm._v(" "), _c('td', [_vm._v("Qualified Tactics Instructor")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter6#G97",
      "id": "rG97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("QWI")])])])]), _vm._v(" "), _c('td', [_vm._v("Qualified Weapons Instructor")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("QWIL")])])]), _vm._v(" "), _c('td', [_vm._v("Qualified Weapons Instructor Leader")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter8#G98",
      "id": "rG98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RAAF")])])])]), _vm._v(" "), _c('td', [_vm._v("Royal Australian Air Force")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Listofplates#G99"
    }
  }, [_vm._v("RAF")])])])]), _vm._v(" "), _c('td', [_vm._v("Royal Air Force")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter9#G100",
      "id": "rG100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RHWR")])])])]), _vm._v(" "), _c('td', [_vm._v("Radar Homing and Warning Receiver")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter9#G101",
      "id": "rG101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RMAF")])])])]), _vm._v(" "), _c('td', [_vm._v("Royal Malaysian Air Force")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter6#G102",
      "id": "rG102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RNEFTS")])])])]), _vm._v(" "), _c('td', [_vm._v("Royal Navy Elementary Flying Training School")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter7#G103",
      "id": "rG103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RNLAF")])])])]), _vm._v(" "), _c('td', [_vm._v("Royal Netherlands Air Force")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter5#G104",
      "id": "rG104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RNoAF")])])])]), _vm._v(" "), _c('td', [_vm._v("Royal Norwegian Air Force")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter3#G105",
      "id": "rG105"
    }
  }, [_vm._v("RPM")])])])]), _vm._v(" "), _c('td', [_vm._v("Revolutions per minute")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter8#G106",
      "id": "rG106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RSAF")])])])]), _vm._v(" "), _c('td', [_vm._v("Royal Saudi Air Force")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter10#G107",
      "id": "rG107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SA")])])])]), _vm._v(" "), _c('td', [_vm._v("Situational Awareness")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter5#G108",
      "id": "rG108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SAM")])])])]), _vm._v(" "), _c('td', [_vm._v("Surface-to-Air Missile")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter8#G109",
      "id": "rG109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SAR")])])])]), _vm._v(" "), _c('td', [_vm._v("Search and Rescue")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter7#G110",
      "id": "rG110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SASO")])])])]), _vm._v(" "), _c('td', [_vm._v("Senior Air Staff Officer")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter9#G111",
      "id": "rG111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SEP")])])])]), _vm._v(" "), _c('td', [_vm._v("Specific Excess Power")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter5#G112",
      "id": "rG112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SEPECAT")])])])]), _vm._v(" "), _c('td', [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Société Européenne de Production de l’avion Ecole de Combat et d’Appui Tactique")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter8#G113",
      "id": "rG113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SHAR")])])])]), _vm._v(" "), _c('td', [_vm._v("Sea Harrier")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter11#G114",
      "id": "rG114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SIFF")])])])]), _vm._v(" "), _c('td', [_vm._v("Successor Identification Friend or Foe")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter3#G115",
      "id": "rG115"
    }
  }, [_vm._v("SNEB")])])])]), _vm._v(" "), _c('td', [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Societe Nouvelle des Etablissements Edgar Brandt")]), _vm._v(" (rockets)")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter11#G116",
      "id": "rG116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("STANEVAL")])])])]), _vm._v(" "), _c('td', [_vm._v("Standards Evaluation (Unit)")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter5#G117",
      "id": "rG117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("STCAAME")])])])]), _vm._v(" "), _c('td', [_vm._v("Strike Command Air-to-Air Missile Establishment")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter5#G118",
      "id": "rG118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TACEVAL")])])])]), _vm._v(" "), _c('td', [_vm._v("Tactical Evaluation (usually for "), _c('a', {
    attrs: {
      "href": "#/xhtml/05_Glossary#rG80"
    }
  }, [_vm._v("NATO")]), _vm._v(")")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TD circle")])])]), _vm._v(" "), _c('td', [_vm._v("Target Detection circle")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter9#G119",
      "id": "rG119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TFM")])])])]), _vm._v(" "), _c('td', [_vm._v("Tactical Fighter Meet")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter7#G120",
      "id": "rG120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TI")])])])]), _vm._v(" "), _c('td', [_vm._v("Tactics Instructor")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter7#G121",
      "id": "rG121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TLP")])])])]), _vm._v(" "), _c('td', [_vm._v("Tactical Leadership Programme")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TMO")])])]), _vm._v(" "), _c('td', [_vm._v("Trials Management Officer")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Listofplates#G122",
      "id": "rG122"
    }
  }, [_vm._v("TRD")])])])]), _vm._v(" "), _c('td', [_vm._v("Towed Radar Decoy")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Listofplates#G123",
      "id": "rG123"
    }
  }, [_vm._v("TWU")])])])]), _vm._v(" "), _c('td', [_vm._v("Tactical Weapons Unit")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter6#G124",
      "id": "rG124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("UAS")])])])]), _vm._v(" "), _c('td', [_vm._v("University Air Squadron")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter10#G125",
      "id": "rG125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("UN")])])])]), _vm._v(" "), _c('td', [_vm._v("United Nations")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter8#G126",
      "id": "rG126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("USAF")])])])]), _vm._v(" "), _c('td', [_vm._v("United States Air Force")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter7#G127",
      "id": "rG127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("USAFE")])])])]), _vm._v(" "), _c('td', [_vm._v("United States Air Forces in Europe")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter12#G128",
      "id": "rG128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VHF")])])])]), _vm._v(" "), _c('td', [_vm._v("Very High Frequency")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter7#G129",
      "id": "rG129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIFF")])])])]), _vm._v(" "), _c('td', [_vm._v("Vectoring in forward flight (by Harriers)")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter7#G130",
      "id": "rG130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIP")])])])]), _vm._v(" "), _c('td', [_vm._v("Very Important Person")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter12#G131",
      "id": "rG131",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VVIP")])])])]), _vm._v(" "), _c('td', [_vm._v("Very-Very Important Person (usually Royalty)")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Visident")])])]), _vm._v(" "), _c('td', [_vm._v("Visual Identification")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("VR")])])]), _vm._v(" "), _c('td', [_vm._v("Volunteer Reserve")])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "glos"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter6#G132",
      "id": "rG132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WRAF")])])])]), _vm._v(" "), _c('td', [_vm._v("Women’s Royal Air Force (merged with the "), _c('a', {
    attrs: {
      "href": "#/xhtml/#rG99"
    }
  }, [_vm._v("RAF")]), _vm._v(" in 1994)")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-073a8894","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Glossary.vue
// module id = 72
// module chunks = 0